import { useState } from 'react';
import { useUnit } from 'effector-react';
import Modal from 'antd/es/modal';
import Input from 'antd/es/input';
import FormItem from 'antd/es/form/FormItem';
import Button from 'antd/es/button';
import Popconfirm from 'antd/es/popconfirm';
import {
  $adminBlockUserModal,
  blockUserEv,
  blockUserFx,
  setAdminBlockUserModalEv,
} from '../../../models/adminSecurityModel/index.js';

export default function AdminBlockUserModal() {
  const { open, uId } = useUnit($adminBlockUserModal);
  const setModal = useUnit(setAdminBlockUserModalEv);

  const blockLoading = useUnit(blockUserFx.pending);

  const [reason, setReason] = useState(null);
  const block = useUnit(blockUserEv);

  return (
    <Modal
      open={open}
      onCancel={() => setModal({ open: false, uId: null })}
      destroyOnClose
      title="Заблокировать пользователя"
      width="50dvw"
      footer={
        <Popconfirm
          title="Вы уверены, что хотите заблокировать данного пользователя?"
          okText="Да"
          onConfirm={() => block({ uId, block_reason: reason })}
        >
          <Button
            type="primary"
            danger
            disabled={!reason || reason?.length < 3}
            loading={blockLoading}
          >
            Подтвердить
          </Button>
        </Popconfirm>
      }
    >
      <FormItem label="Причина блокировки" layout={'vertical'}>
        <Input value={reason} onChange={(e) => setReason(e.target.value)} />
      </FormItem>
    </Modal>
  );
}
